import { ExamBuilder } from "../../components/ExamBuilder"

export const ExamBuilderPage = () => {

    return(
        <ExamBuilder />
    )
}